import React, { useEffect, useContext } from "react";
import AOS from "aos";
import "./PricingCards.scss";
import cardDataMonthly from "./PricingCardsListMonthly.json";
import cardDataYearly from "./PricingCardsListYearly.json";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Context/AuthContext";

function formatFeaturesWithColors(feature) {
  const parts = feature.split(/(\d+)/).map((part, index) =>
    /\d+/.test(part) ? (
      <span key={index} className="numbers">
        {part}
      </span>
    ) : (
      part
    )
  );
  return <>{parts}</>;
}

function PricingCards() {
  useEffect(() => {
    AOS.init();
  }, []);

  const navigate = useNavigate();
  const { _auth } = useContext(AuthContext);

  const handleFree = () => navigate(_auth ? "/chatbot" : "/login");

  return (
    <React.Fragment>
      <div className="pricingCards">
        <div className="container">
          <div className="title" data-aos="fade-up" data-aos-duration="1000">
            <p>
              Explore contract review on the Free plan. Listed paid rates are
              legacy information only; checkout and paid access are currently unavailable.
            </p>
          </div>
          <div className="tabsBlock">
            <Tabs defaultActiveKey="monthly" id="uncontrolled-tab-example">
              <Tab eventKey="monthly" title="Monthly">
                <div className="cards zoom-container">
                  <div className="row justify-content-center">
                    {cardDataMonthly.map((card) => (
                      <div
                        className="col-md-4 col-lg-4 my-3"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        key={card.id}
                      >
                        <div className="card">
                          <p className="card-title">{card.title}</p>
                          <p className="price">
                            ${card.price}
                          </p>
                          <p className="card-text">{card.description}</p>
                          <button className="chosebtn"
                            onClick={card.title === "Free" ? handleFree : undefined}
                            disabled={card.title !== "Free"}
                          >
                            {card.title === "Free" ? "Start for Free" : "Checkout unavailable"}
                          </button>
                          <ul>
                            {card.features.map((feature, index) => (
                              <li key={index}>
                                {formatFeaturesWithColors(feature)}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Tab>
              <Tab eventKey="yearly" title="Yearly">
                <div className="cards">
                  <div className="row justify-content-center">
                    {cardDataYearly.map((card) => (
                      <div
                        className="col-md-6 col-lg-4 my-3"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        key={card.id}
                      >
                        <div className="card">
                          <p className="card-title">{card.title}</p>
                          <p className="price">
                            ${card.price}
                          </p>
                          <p className="card-text">{card.description}</p>
                          <button
                            onClick={card.title === "Free" ? handleFree : undefined}
                            disabled={card.title !== "Free"}
                          >
                            {card.title === "Free" ? "Start for Free" : "Checkout unavailable"}
                          </button>
                          <ul>
                            {card.features.map((feature, index) => (
                              <li key={index}>
                                {formatFeaturesWithColors(feature)}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PricingCards;
